import api, { checkTokenErrorResponse } from '..';

export async function postTraining(classId, data, hora_inicio, hora_fim, frequencia = 'N') {
    return api.post(`turmas/${classId}/treinos/`, {
        data,
        frequencia,
        hora_inicio,
        hora_fim
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getTrainings(classId, data = null) {
    return api.get(`turmas/${classId}/treinos/${data ? `?data=${data}` : ''}`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getAcademyTrainings(data = null) {
    return api.get(`treinos/${data ? `?data=${data}` : ''}`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteTraining(classId, trainingId) {
    return api.delete(`turmas/${classId}/treinos/${trainingId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const trainingsServices = {
    postTraining,
    getTrainings,
    getAcademyTrainings,
    deleteTraining,
}
export default trainingsServices;